<div class="tw-mr-1 tw-text-sm tw-flex-center " [class.cursor-pointer]="!noSorting" [class]="sort===1||sort===2?'text-blue':''"
  (click)="changeSort()">



  <!-- sorter -->
  <span *ngIf="!noSorting">

    <i class="mdi mdi-sort text-dark mdi-17px tw-opacity-30 tw-mb-[2px] tw-mx-[2px]" [class]="sort===0?'':'d-none'"></i>

    <i class="mdi mdi-sort-ascending mdi-17px tw-mb-[2px] text-blue" [class]="sort===1?'':'d-none'"></i>

    <i class="mdi mdi-sort-descending mdi-17px tw-mb-[2px] text-blue" [class]="sort===2?'':'d-none'"></i>

  </span>

</div>
